import type { StyleRule } from '@archipro-design/aria';
import { pxArrayToRem, pxToRem } from '@archipro-design/aria';
import { MOBILE_INPUT_BG } from '@modules/design-board/component/share-modal/MobileShareBoardModal.style';

export const PillContainer: StyleRule = () => ({
    padding: pxArrayToRem([13, 5]),
    backgroundColor: MOBILE_INPUT_BG,
    maxHeight: pxToRem(161),
    overflowY: 'auto',
});

export const Pill: StyleRule = ({ theme }) => ({
    position: 'relative',
    display: 'inline-block',
    maxWidth: '100%',
    margin: pxArrayToRem([0.8, 0]),
    ...theme.siteVariables.textStyles.Text.Roman55,
    height: pxToRem(36),
    padding: pxArrayToRem([10, 34, 10, 14]),
    borderRadius: pxToRem(18),
    fontSize: theme.siteVariables.fontSizes.caption03,
    lineHeight: theme.siteVariables.lineHeightDefault,
    backgroundColor: theme.siteVariables.colors.charcoal['200'],
    color: theme.siteVariables.colors.white['FFF'],
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
});

export const PillRemove: StyleRule = ({ theme }) => ({
    position: 'absolute',
    right: pxToRem(14),
    top: '50%',
    transform: 'translateY(-50%)',
    width: `${pxToRem(12)} !important`,
    height: `${pxToRem(12)} !important`,

    '& svg': {
        width: pxToRem(12),
        height: pxToRem(12),
    },

    '& svg path': {
        fill: theme.siteVariables.colors.white['FFF'],
    },
});
